<template>
    <div>
        <el-dialog
            :title="dialogTitle"
            width="950px"
            :visible.sync="splitDetailFlag"
            @close='closeDialog'
            :close-on-click-modal='false'>
            <el-divider></el-divider>
            <div v-if='step == 1'>
                <div style='font-weight: bold;'>基本信息</div>
                <div style="margin-top: 20px;width: 800px">
                    <taxform :Formlist="basicInfo" labelPosition='left' ref="taxForm" labelwidth="100px" :column="2" :formdata="basicInfoData" style="padding-left: 20px;" ></taxform>
                </div>
                <el-divider></el-divider>
                <div style='font-weight: bold;'>票据信息</div>
                <div style="margin-top: 20px; width: 800px">
                    <taxform :Formlist="docInfo" labelPosition='left' ref="taxForm" labelwidth="100px" :column="2" :formdata="docInfodata" style="padding-left: 20px;" ></taxform>
                </div>
                <el-divider></el-divider>
                <div style='font-weight: bold;'>票据明细</div>
                <div style="margin-top: 20px;">
                    <taxtable :headData='docDetailHead' :tableData="docDetailData" showSelection ref="docDetailTable" @selectionchange="handleSelectionChange">
                        <template v-slot:hansbz="scope">
                            <p v-if="scope.taxval.kaiplx == '0'">是</p>
                            <p v-else>否</p>
                        </template>
                    </taxtable>
                </div>
                <div style='padding: 20px; text-align: right;'>
                    <el-button type="warning" @click='groupClick'>分组</el-button>
                    <el-button type="success" @click='splictDocDetailClick'>拆分</el-button>
                    <el-button type="primary" @click='saveSplitResult'>保存</el-button>
                    <el-button @click='closeDialog'>关闭</el-button>
                </div>
            </div>
            <div v-if='step == 2'>
                <div style='font-weight: bold;'>拆分方式</div>
                <div style='margin-top: 20px;'>
                    <el-radio-group v-model="splitType" @change='splitTypeChange'>
                        <el-radio :label="1">金额</el-radio>
                        <el-radio :disabled="selectDocDetailList[0].shangpsl=='' || selectDocDetailList[0].shangpsl== null || selectDocDetailList[0].danj == '' || selectDocDetailList[0].danj == null" style='margin-left: 40px;' :label="2">数量</el-radio>
                        <el-radio :disabled="selectDocDetailList[0].shangpsl=='' || selectDocDetailList[0].shangpsl== null || selectDocDetailList[0].danj == '' || selectDocDetailList[0].danj == null"  style='margin-left: 40px;' :label="3">单价</el-radio>
                    </el-radio-group>
                </div>
                <div style='margin-top: 20px; display: flex; '>
                    <el-select v-model="splitChoice" placeholder="请选择拆分方式" @change='splitChoiceChange'>
                        <el-option
                            v-for="item in splitOptions[splitType - 1]"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                    <div>
                        <div v-for='(item,index) in splitValue' :key='index'>
                            <div class="Centerupdown " style='margin-bottom: 10px;'>
                                <el-input-number min='1' precision='0' style='margin-left: 20px;' v-if='splitType == 1 && splitChoice == 1' v-model='splitValue[index]' :controls='false' label="" @change='inputChange($event,index)'></el-input-number>
                                <el-input-number min='0' style='margin-left: 20px;' v-else-if='splitType == 1 && splitChoice == 3' :precision="2" v-model='splitValue[index]' :controls='false' label="" @change='inputChange($event,index)'></el-input-number>
                                <el-input-number min='0' style='margin-left: 20px;' v-else-if='splitType != 2 || splitChoice != 1' v-model='splitValue[index]' :controls='false' label="" @change='inputChange($event,index)'></el-input-number>
                                <el-button v-if='index == 0 && (splitType == 1 && splitChoice != 1 || splitType == 2 && splitChoice == 2) ' style='margin-left: 10px;' @click='addItem'>添加</el-button>
                                <el-button v-if='index > 0' style='margin-left: 10px;' @click='delItem(index)'>删除</el-button>
                            </div>
                        </div>
                    </div>
                    <div>
                        <el-button style='margin-left: 200px;' @click='previewResult'>预览拆分结果</el-button>
                    </div>
                </div>
                <div style='font-weight: bold; margin-top: 20px;'>原单据明细</div>
                <div style="margin-top: 20px;">
                    <taxtable :headData='docDetailHead' :tableData="selectDocDetailList" tableHeight='auto'>
                        <template v-slot:hansbz="scope">
                            <p v-if="scope.taxval.kaiplx == '0'">是</p>
                            <p v-else>否</p>
                        </template>
                    </taxtable>
                </div>
                <div style='font-weight: bold; margin-top: 20px;'>拆分结果</div>
                <div style="margin-top: 20px;">
                    <taxtable :headData='resultHead' :tableData="splitResultData">
                        <template v-slot:no="scope">
                            <div >{{ scope.index + 1 }}</div>
                        </template>
                        <template v-slot:zhanb='scope'>
                            {{calculationProportion(scope.taxval.jine)}}
                        </template>
                    </taxtable>
                </div>
                <div style='padding: 20px; text-align: right;'>
                    <el-button type="primary" @click='splitFinish'>确定</el-button>
                    <el-button @click='step--'>关闭</el-button>
                </div>
            </div>

        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'manualSplit',
    props:{
        splitDetailFlag:{
            type:Boolean,
            default:false
        },
        splitDetailData:{
            type:Object,
            default: {}
        },
    },
    data() {

        return {

            step:1,
            dialogTitle:"手工拆分",
            dialogVisible:true,
            basicInfo:[
                {
                    prop: "danjh",
                    label: "单据编号",
                    type: "input",
                    width:"200px",
                    disabled:true
                },
                {
                    prop: "goufmc",
                    label: "客户名称",
                    type: "input",
                    width:"200px",
                    disabled:true
                }
            ],
            basicInfoData:{
                danjh:'',
                goufmc:''
            },
            docInfo:[
                {
                    prop: "jine",
                    label: "不含税金额",
                    type: "input",
                    width:"200px",
                    disabled:true
                },
                {
                    prop: "hansje",
                    label: "含税金额",
                    type: "input",
                    width:"200px",
                    disabled:true
                }, {
                    prop: "shuie",
                    label: "税额",
                    type: "input",
                    width:"200px",
                    disabled:true
                }
            ],
            docInfodata:{
                jine:'',
                hansje:'',
                shuie:''
            },
            docDetailData:[],
            docDetailHead:[
                {
                    title: "分组",
                    prop: "group",
                    width: "50"
                }, {
                    title: "商品名称",
                    prop: "shangpmc",
                    width: "150"
                }, {
                    title: "规格型号",
                    prop: "guigxh",
                    width: "100"
                }, {
                    title: "数量",
                    prop: "shangpsl",
                    width: "80"
                }, {
                    title: "单价",
                    prop: "danj",
                    width: "100"
                }, {
                    title: "金额",
                    prop: "jine",
                    width: "100"
                }, {
                    title: "税额",
                    prop: "shuie",
                    width: "100"
                }, {
                    title: "折扣金额",
                    prop: "zhekje",
                    width: "100"
                }, {
                    title: "折扣税额",
                    prop: "zhekse",
                    width: "100"
                }, {
                    title: "含税标识",
                    prop: "hansbz",
                    width: "75",
                    custom: true,
                }
            ],


            splitType:1,
            splitOptions:[
                [
                    {label:'按行数',value:1},
                    {label:'按比例',value:2},
                    {label:'自定义金额',value:3},
                ],[
                    {label:'按整数',value:1},
                    {label:'自定义数量',value:2},
                ],[
                    {label:'自定义单价',value:1},
                ]
            ],
            splitChoice:1,
            splitValue:[''],

            resultHead:[
                {
                    title: "序号",
                    prop: "no",
                    width: "150",
                    custom: true,
                }, {
                    title: "数量",
                    prop: "shangpsl",
                    width: "150"
                }, {
                    title: "单价",
                    prop: "danj",
                    width: "150"
                }, {
                    title: "金额",
                    prop: "jine",
                    width: "150"
                }, {
                    title: "税额",
                    prop: "shuie",
                    width: "150"
                },{
                    title: "占比",
                    prop: "zhanb",
                    width: "150",
                    custom: true,
                },
            ],
            selectDocDetailList:[],
            splitResultData:[],
            groupNum:0,
            baseRuleList:[],
        };
    },
    created() {
        this.splitType = 1;
        this.splitChoice = 1;
        this.splitValue = [''];
        this.basicInfoData.danjh = this.splitDetailData.stateall.docNo
        this.basicInfoData.goufmc = this.splitDetailData.ruleFormbxiao.name
        this.docInfodata.jine = this.splitDetailData.totalall.pricetotal;
        this.docInfodata.hansje = this.splitDetailData.totalall.jiastotal;
        this.docInfodata.shuie = this.splitDetailData.totalall.taxtotal;
        let data = this.splitDetailData.priceall;
        this.docDetailData = [];
        for (let i = 0; i < data.length; i++) {
            let rowData = data[i];
            let row = {
                id:rowData.id,
                group:'',
                shangpmc:rowData.goodsName,
                guigxh:rowData.spec,
                shangpsl:rowData.quantity,
                danj:rowData.unitPrice,
                jine:rowData.chooseMoney,
                shuie:rowData.taxRatemoney,
                zhekje:rowData.zhekje,
                hansbz:this.splitDetailData.stateall.istaxincluded ? 0 : 1,
                youhzcbz:rowData.taxIncentivePolicySign,
                youhzcsm:rowData.taxIncentivePolicyDescription,
            }
            this.docDetailData.push(row);
            this.findBaseRules();
        }
    },
    methods: {
        findBaseRules(){
            this.$https.fetchPost("rule/findBaseRules").then(res => {
                if (res.data.success) {
                    this.baseRuleList = res.data.obj;
                }
            })
        },
        splitFinish(){
          this.step--;
          if (this.splitResultData.length > 0) {
              this.docDetailData = this.docDetailData .filter(item => item.id != this.selectDocDetailList[0].id);
              for (let i = 0; i < this.splitResultData.length; i++) {
                  this.docDetailData.push(this.splitResultData[i]);
              }
          }
          this.splitResultData = [];
        },
        /**
         * 保存最终结果
         */
        saveSplitResult(){
            let params = {
                details:this.docDetailData,
                docId: this.splitDetailData.id
            }
            this.$https.fetchPost("doc/saveSplitDocDetailResult",JSON.stringify(params)).then(res=>{
                 if (res.data.success) {
                     this.splitDetailFlag = false;
                     this.$emit("closeSplitDetailDialogAndRefresh");
                 }
            })
        },
        //预览结果
        previewResult(){
            if(this.splitType == '1' && this.splitChoice == '1') {
                if (this.splitValue[0] == 0) {
                    this.$message({ type: 'error', message: '请输入行数！' });
                    return;
                }
            }
            if(this.splitType == '1' && this.splitChoice == '2') {
                this.splitValue = this.splitValue.filter(item => item != 0);
                if (this.splitValue.length == 0) {
                    this.splitValue = ['']
                    this.$message({ type: 'error', message: '请输入比例！' });
                    return;
                }
            }
            if(this.splitType == '1' && this.splitChoice == '3') {

                if (this.splitValue[0] == '0.00') {
                    this.$message({ type: 'error', message: '请输入金额！' });
                    return;
                }
            }
            if(this.splitType == '2' && this.splitChoice == '2') {
                this.splitValue = this.splitValue.filter(item => item != 0);
                if (this.splitValue.length == 0) {
                    this.splitValue = ['']
                    this.$message({ type: 'error', message: '请输入数量！' });
                    return;
                }
            }
            if(this.splitType == '3' && this.splitChoice == '1') {
                if (this.splitValue[0] <= 0) {
                    this.$message({ type: 'error', message: '请输入单价！' });
                    return;
                }
            }
            let params = {
                splitType:this.splitType,
                splitChoice:this.splitChoice,
                splitValue:this.splitValue.join(","),
                docDetailId:this.selectDocDetailList[0].id,
                docId:this.splitDetailData.id,
            };
            this.$https.fetchPost("doc/splitDocDetail",JSON.stringify(params)).then(res => {
                if (res.data.success) {
                    this.splitResultData = res.data.obj;
                }
            })
        },
        addItem(){
            this.splitValue.push("")
        },
        delItem(index){
            this.splitValue.splice(index,1);
            if (this.splitType == '1' && this.splitChoice == '2') {
                this.delCalculate(100);
            } else if (this.splitType == '1' && this.splitChoice == '3') {
                let chooseMoney = this.selectDocDetailList[0].jine;
                if (chooseMoney != null && chooseMoney != '') {
                    chooseMoney = Number.parseFloat(chooseMoney);
                }
                this.delCalculate(chooseMoney);
            } else if (this.splitType == '2' && this.splitChoice == '2') {
                let num = this.selectDocDetailList[0].shangpsl;
                if (num != null && num != '') {
                    num = Number.parseFloat(num);
                }
                this.delCalculate(num);
            }
        },
        splitTypeChange(){
            this.splitValue = [''];
            this.splitChoice = 1;
        },
        splitChoiceChange(data){
            this.splitValue = [''];
        },
        closeDialog(){
            if (this.step == 2) {
                this.step--;
                this.splitDetailFlag = true;
                return;
            }
            this.splitDetailFlag = false;
            this.$emit("closeSplitDetailDialog")
        },
        handleSelectionChange(e){
            this.selectDocDetailList = e;
        },
        splictDocDetailClick(){
            if (this.selectDocDetailList.length > 1) {
                this.$message({ type: 'error', message: '只能选择一条明细' });
                return;
            }
            if (this.selectDocDetailList.length < 1) {
                this.$message({ type: 'error', message: '至少选择一条明细' });
                return;
            }
            if (this.selectDocDetailList[0].id == '' || this.selectDocDetailList[0].id == null) {
                this.$message({ type: 'error', message: '拆分生成的明细不能再次拆分！' });
                return;
            }
            this.splitValue = [''];
            this.splitChoice = 1;
            this.splitResultData = [];
            this.step++;
        },
        inputChange(currentValue, index){
            if (this.splitType == '1' && this.splitChoice == '2') {
                //按金额拆分 - 按比例
                if (currentValue >= 100) {
                    this.$message({ type: 'error', message: '填写比例不能大于100' });
                    this.splitValue[index] = '';
                    return;
                }
                this.addCalculate(100,index);
            }
            else if (this.splitType == '1' && this.splitChoice == '3') {
                //按金额拆分，自定义金额
                let chooseMoney = this.selectDocDetailList[0].jine;
                if (chooseMoney != null && chooseMoney != '') {
                    chooseMoney = Number.parseFloat(chooseMoney);
                }
                if (currentValue >= chooseMoney) {
                    this.$message({ type: 'error', message: '填写金额不能大于' + chooseMoney });
                    this.splitValue[index] = '';
                    return;
                }
                this.addCalculate(chooseMoney,index);
            } else if (this.splitType == '2' && this.splitChoice == '2') {
                let num = this.selectDocDetailList[0].shangpsl;
                if (num != null && num != '') {
                    num = Number.parseFloat(num);
                }
                if (currentValue >= num) {
                    this.$message({ type: 'error', message: '填写数量不能大于' + num });
                    this.splitValue[index] = '';
                    return;
                }
                this.addCalculate(num,index);
            } else if (this.splitType == '3' && this.splitChoice == '1') {
                let num = this.selectDocDetailList[0].danj;
                if (num != null && num != '') {
                    num = Number.parseFloat(num);
                }
                if (currentValue >= num) {
                    this.$message({ type: 'error', message: '填写单价不能大于' + num });
                    this.splitValue[index] = '';
                    return;
                }
            }
        },

        groupClick(){
            if (this.selectDocDetailList.length < 1) {
                this.$message.error("请选择需要分组的数据");
                return;
            }
            //判断是否超过限额
            let fplxdm = this.splitDetailData.stateall.choosetitleindex;
            if (this.baseRuleList.length > 0) {
                let filterRule = this.baseRuleList.filter(item => item.fplxs == fplxdm);
                if (filterRule.length > 0) {
                    let sumMoney = 0;
                    this.selectDocDetailList.forEach(item => sumMoney = this.numAdd(sumMoney,item.jine));
                    if (sumMoney > filterRule[0].hansje) {
                        this.$message.error("分组超过限额，请重新分组");
                        return;
                    }
                } else {
                    this.$message.error("请先配置基础规则");
                    return;
                }
            } else {
                this.$message.error("请先配置基础规则");
                return;
            }

            this.groupNum++;
            this.selectDocDetailList.forEach(item => item.group = this.groupNum);

            let data = JSON.parse(JSON.stringify(this.docDetailData)) ;
            this.docDetailData = data;
        },
        addCalculate(maxNum,index){
            let sum = 0;
            this.splitValue.forEach((value) => {sum = this.numAdd(sum ,value);});
            if (sum < maxNum) {
                this.splitValue = this.splitValue.filter(item => item != '' && item != 0);
                this.splitValue.push(this.numSub(maxNum,sum));
            } else {
                let disparity = sum - maxNum;
                for (let i = this.splitValue.length - 1; i >= 0; i--) {
                    if (i != index) {
                        if (this.numSub(this.splitValue[i],disparity) > 0) {
                            this.splitValue[i] = this.numSub(this.splitValue[i],disparity);
                            break;
                        } else {
                            disparity = this.numSub(disparity,this.splitValue[i]);
                            this.splitValue[i] = "";
                        }
                    }
                }
                this.splitValue = this.splitValue.filter(item => item != '' && item != 0);
            }
        },
        delCalculate(maxNum) {
            let sum = 0;
            this.splitValue.forEach((value) => {sum =this.numAdd(sum ,value);});
            if (sum != 0) {
                this.splitValue[this.splitValue.length - 1] = this.numAdd(this.splitValue[this.splitValue.length - 1],(maxNum - sum));
            }
            if (this.splitValue[0] == maxNum) {
                this.splitValue[0] = 0;
            }
        },

        //计算占比
        calculationProportion(money){
            let result = this.numdiv(money,this.selectDocDetailList[0].jine);
            return result.toFixed(4) * 100 + "%"
        },

        //加法计算
        numAdd(num1, num2) {
            var baseNum, baseNum1, baseNum2;
            try {
                baseNum1 = num1.toString().split(".")[1].length;
            } catch (e) {
                baseNum1 = 0;
            }
            try {
                baseNum2 = num2.toString().split(".")[1].length;
            } catch (e) {
                baseNum2 = 0;
            }
            baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
            return (num1 * baseNum + num2 * baseNum) / baseNum;
        },
        //减法计算
        numSub(num1, num2) {
            var baseNum, baseNum1, baseNum2;
            var precision;// 精度
            try {
                baseNum1 = num1.toString().split(".")[1].length;
            } catch (e) {
                baseNum1 = 0;
            }
            try {
                baseNum2 = num2.toString().split(".")[1].length;
            } catch (e) {
                baseNum2 = 0;
            }
            baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
            precision = (baseNum1 >= baseNum2) ? baseNum1 : baseNum2;
            return ((num1 * baseNum - num2 * baseNum) / baseNum).toFixed(precision);
        },
        //除法计算
        numdiv(arg1,arg2){
            var t1=0,t2=0,r1,r2;
            try{t1=arg1.toString().split(".")[1].length}catch(e){}
            try{t2=arg2.toString().split(".")[1].length}catch(e){}
            //with(Math){
            r1=Number(arg1.toString().replace(".",""))
            r2=Number(arg2.toString().replace(".",""))
            return (r1/r2)*Math.pow(10,t2-t1);
            //}
        },
    }

};


</script>

<style scoped>
/deep/ .el-table__body-wrapper {
    min-height: auto!important;
}

</style>